import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from 'config/store';
import Sentry from 'config/Sentry';
import { registerPreloadErrorListener } from 'config/ChunkReload';
import reportWebVitals from './reportWebVitals';
import Translation from './config/translation/i18n';
import i18n from 'i18next';
import { I18nextProvider } from 'react-i18next';
import Root from './Root';
import * as serviceWorker from './serviceWorker';
import { isDevelop as isDevelopFromReactAppEnv } from 'modules/Utils';

if (!isDevelopFromReactAppEnv) {
  Sentry.init();
}

// Covers the dynamic imports that never reach lazyWithReload, such as the whitelabel
// bundle loaded during the first render.
registerPreloadErrorListener();

const container = document.getElementById('root');
const root = createRoot(container);

Translation.init(() =>
  root.render(
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <Root />
      </I18nextProvider>
    </Provider>
  )
);

// Service worker for PWA support
serviceWorker.register();

// Web vitals reporting
reportWebVitals();
